import type { IInstallJob, IMediaPushJob } from "../state/deviceInstallerSlice";
import { CANCELLED_SENTINEL } from "../constants";

export interface DerivedJobStatus {
  isCancelled: boolean;
  isSuccess: boolean;
  isError: boolean;
  isDone: boolean;
}

export function deriveInstallJobStatus(job: IInstallJob): DerivedJobStatus {
  const isCancelled = job.status === "error" && job.errorMessage === CANCELLED_SENTINEL;
  const isSuccess = job.status === "success";
  const isError = job.status === "error" && !isCancelled;
  const isDone = isSuccess || isError || isCancelled;
  return { isCancelled, isSuccess, isError, isDone };
}

export function deriveMediaPushJobStatus(job: IMediaPushJob): DerivedJobStatus {
  const isCancelled = job.status === "cancelled";
  const isSuccess = job.status === "success";
  const isError = job.status === "error";
  const isDone = isSuccess || isError || isCancelled;
  return { isCancelled, isSuccess, isError, isDone };
}
